export default __webpack_public_path__ + "static/media/K.04b9fd05.svg";